<template>
  <div class="loginCon" style="width: 100%; height: 100%">
    <div class="aui-content" v-show="type === 'login'">
      <div class="my-container">
        <div class="my-container_l" ref="l">
          <svg
            version="1.1"
            class="my-svg"
            width="303px"
            style="position: absolute; top: 239px; left: 393px"
            height="320px"
          >
            <defs>
              <linearGradient id="linear" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stop-color="rgba(16,32,73,0)" />
                <stop offset="50%" stop-color="rgba(8,68,158,0)" />
                <stop offset="80%" stop-color="rgba(6,81,191,0.18)" />
                <stop offset="100%" stop-color="rgba(0,108,255,0.35)" />
              </linearGradient>
              <linearGradient id="linear1" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stop-color="#0f8bf1" />
                <stop offset="50%" stop-color="#03ffea" />
                <stop offset="100%" stop-color="#0f8bf1" />
              </linearGradient>
            </defs>

            <polygon
              class="g-polygon-move"
              fill="url(#linear)"
              stroke="url(#linear1)"
              points="150 0, 303 77, 303 245, 153 320, 0 245,  0 77, 150 0"
            />
          </svg>
          <p class="enterName" data-text="依申请公开">依申请公开</p>
          <img
            class="enterLog"
            src="../../assets/img/dalianyunguangxiaotu.png"
            alt=""
          />
          <!-- <img class="sign1" src="../../assets/img/数据1.png" alt="" />
          <img class="sign2" src="../../assets/img/数据2.png" alt="" />
          <img class="sign3" src="../../assets/img/数据3.png" alt="" />
          <img class="sign4" src="../../assets/img/数据4.png" alt="" /> -->
        </div>
        <div class="my-container_r" ref="r">
          <div class="my-login_box">
            <div class="aui-formBox">
              <div class="aui-formWell">
                <div class="aui-form-nav investment_title">
                  <div
                    style="
                      color: #0053ff;
                      font-size: 31px;
                      padding-bottom: 20px;
                      font-family: 'youyuan';
                      justify-content: center;
                    "
                    class="aui-flex-box"
                    @click="loginClick('accountLogin')"
                  >
                    <span>用户登录</span>
                  </div>
                  <div class="aui-form-box">
                    <el-form
                      :model="formData"
                      @keyup.enter.native="loginHandleClick"
                    >
                      <el-row class="inpRow">
                        <i class="icon-code"></i>
                        <el-input
                          style="border: none"
                          v-model="formData.username"
                          class="w-50 m-2"
                          placeholder="账号"
                        />
                      </el-row>
                      <el-row class="inpRow">
                        <i class="icon-password"></i>
                        <el-input
                          type="password"
                          style="border: none"
                          v-model="formData.password"
                          class="w-50 m-2"
                          placeholder="密码"
                        />
                      </el-row>
                      <el-row class="inpRow">
                        <i class="icon-code"></i>
                        <el-input
                          style="border: none"
                          v-model="formData.inputCode"
                          class="w-50 m-2"
                          placeholder="验证码"
                        />
                        <div class="aui-code">
                          <img
                            v-if="randCodeData.requestCodeSuccess"
                            :src="randCodeData.randCodeImage"
                            @click="handleChangeCheckCode"
                          />

                          <img
                            v-else
                            @click="handleChangeCheckCode"
                            src="../../assets/img/checkcode.png"
                            alt=""
                          />
                        </div>
                      </el-row>
                      <div class="aui-flex">
                        <div class="aui-flex-box">
                          <el-checkbox
                            @change="readmeFn"
                            v-model="checked1"
                            label="记住我"
                            size="large"
                          />
                        </div>
                        <!-- <div class="aui-forget">
                          <el-link type="primary">忘记密码？</el-link>
                        </div> -->
                      </div>
                    </el-form>
                  </div>
                  <div class="aui-formButton">
                    <div class="aui-flex">
                      <el-button
                        :loading="loginLoading"
                        style="
                          background: linear-gradient(0deg, #0053ff, #107af5);
                          border-radius: 6px;
                          margin-top: 80px;
                          font-family: 'youyuan';
                        "
                        class="aui-link-login aui-flex-box btn"
                        type="primary"
                        @click="loginHandleClick"
                      >
                        立即登录</el-button
                      >
                    </div>
                    <div class="aui-flex">
                      <el-button
                        :loading="loginLoading"
                        style="
                          border-radius: 6px;
                          margin-top: 80px;
                          font-family: 'youyuan';
                          margin-bottom: 30px;
                        "
                        class="aui-link-login aui-flex-box a"
                        type="primary"
                        @click="registerHandleClick"
                      >
                        注册</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">技术支持: 大连云数据科技有限公司</div>
    </div>
    <div class="aui-content" v-show="type === 'register'">
      <div class="aui-container">
        <div class="hh">
          <div class="aui-image">
            <div class="aui-image-text">
              <img
                style="width: 440px"
                src="../../assets/img/jeecg_ad_text.png"
                alt=""
              />
            </div>
          </div>
          <div class="aui-formBox ee">
            <div class="aui-formWell">
              <el-form style="height: 100%">
                <div class="title">
                  <div class="qq">注册</div>
                </div>
                <div class="aui-form-box" style="height: 334px">
                  <div
                    class="aui-account"
                    style="padding-top: 20px; padding-bottom: 40px"
                  >
                    <el-form-item class="formItem">
                      <el-input
                        v-model="res.username"
                        class="in2"
                        placeholder="账号"
                        :prefix-icon="User"
                      />
                    </el-form-item>
                    <el-form-item class="formItem">
                      <el-input
                        type="password"
                        show-password
                        v-model="res.password"
                        class="in2"
                        placeholder="密码"
                        :prefix-icon="Lock"
                      />
                    </el-form-item>
                    <el-form-item class="formItem">
                      <el-input
                        type="password"
                        show-password
                        v-model="res.confirmPassword"
                        class="in2"
                        placeholder="确认密码"
                        :prefix-icon="Lock"
                      />
                    </el-form-item>
                    <el-form-item>
                      <el-radio-group v-model="res.dentity" class="ml-4">
                        <el-radio label="1" size="large">公民</el-radio>
                        <el-radio label="2" size="large"
                          >法人/其他组织</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </div>
              </el-form>
              <button
                @click="registerHandleClicks"
                style="background: #1b90ff; color: #fff"
                class="myBtn c"
              >
                注册
              </button>
              <button
                @click="reLogin"
                style="
                  margin-top: 10px;
                  border: 1px solid #dbdbdb;
                  background: #fff;
                "
                class="myBtn v"
              >
                返回
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref, defineComponent, toRaw } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getCodeInfo, register, getGssionid } from "../../api/login/index";
import { User, Lock } from "@element-plus/icons-vue";
import { ElMessage, ElLoading } from "element-plus";
export default defineComponent({
  setup() {
    const type = ref("login");
    let router = useRouter();
    let store = useStore();
    const randCodeData = reactive({
      randCodeImage: "",
      requestCodeSuccess: false,
      checkKey: null,
    });
    let checked1 = ref(false);
    let loading = ref();
    let formData = reactive({
      username: "",
      password: "",
      captcha: "",
      checkKey: "",
    });
    const readmeFn = (val) => {
      checked1.value = val;
      if (checked1.value) {
        localStorage.setItem(
          "formData",
          JSON.stringify({
            username: formData.username,
            password: formData.password,
            checked1: checked1.value,
          })
        );
      } else {
        localStorage.setItem(
          "formData",
          JSON.stringify({
            username: "",
            password: "",
            checked1: checked1.value,
          })
        );
      }
    };
    let res = reactive({
      confirmPassword: "",
      dentity: "1",
      password: "",
      username: "",
    });
    // router.beforeRouteEnter((to, from, next) => {
    //   console.log(to, from, next);
    // });

    // function handlegetGssionid() {
    //   getGssionid().then((res) => {
    //     console.log(res);
    //   });
    // }
    function reLogin() {
      type.value = "login";
    }
    //注册
    function registerHandleClick() {
      type.value = "register";
      setTimeout(() => {
        registerRef.value.initForm();
      }, 300);
    }
    function registerHandleClicks() {
      if (!res.username) {
        console.log("请输入姓名");
        return;
      }
      // if (!formData.mobile) {
      //   createMessage.warn(t('sys.login.mobilePlaceholder'));
      //   return;
      // }
      // if (!formData.smscode) {
      //   createMessage.warn(t('sys.login.smsPlaceholder'));
      //   return;
      // }
      if (!res.password) {
        ElMessage({
          message: "请输入密码",
          type: "warning",
        });

        return;
      }
      if (!res.confirmPassword) {
        ElMessage({
          message: "请确认密码",
          type: "warning",
        });

        return;
      }
      if (res.password !== res.confirmPassword) {
        ElMessage({
          message: "两次密码不一致",
          type: "warning",
        });

        return;
      }
      var rules =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~!@#$%^&*)(_+}{|:?><]).{8,15}$/;
      if (!rules.test(res.password)) {
        ElMessage({
          message: "请输入8-15位大写字母+小写字母+数字+特殊字符",
          type: "warning",
        });
        return;
      }
      // if (!formData.policy) {
      //   createMessage.warn(t('sys.login.policyPlaceholder'));
      //   return;
      // }
      registerAccount();
    }
    function registerAccount() {
      register(res).then((val) => {
        console.log(val.message);
      });
    }
    //选择二维码
    const handleChangeCheckCode = () => {
      formData.inputCode = "";

      randCodeData.checkKey = 1629428467008;
      getCodeInfo(randCodeData.checkKey).then((res) => {
        randCodeData.randCodeImage = res;
        randCodeData.requestCodeSuccess = true;
      });
    };

    //登录按钮
    const loginHandleClick = () => {
      loading = ElLoading.service({
        lock: true,
        text: "登录中...",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let obj = {};
      // let obj = {
      //   password: formData.password,
      //   username: formData.username,
      //   captcha: formData.inputCode,
      //   checkKey: randCodeData.checkKey,
      //   mode: "none", //不要默认的错误提示
      // };
      // if (!obj.username) {
      //   ElMessage({
      //     message: "请输入用户名",
      //     type: "warning",
      //   });
      //   return;
      // }
      // if (!obj.password) {
      //   ElMessage({
      //     message: "请输入密码",
      //     type: "warning",
      //   });
      //   return;
      // }

      // if (!obj.captcha) {
      //   ElMessage({
      //     message: "请输入验证码",
      //     type: "warning",
      //   });
      //   return;
      // }
      store.dispatch("user/login", obj).then(
        (val) => {
          // alert("登录成功");
          localStorage.removeItem("trsidsssosessionid");
          loading.close();
        },
        (val) => {
          loading.close();
        }
      );
    };
    onMounted(() => {
      let arr = toRaw(router).currentRoute.value.fullPath.split("url=");
      let Base64 = require("js-base64").Base64;
      if (arr[1]) {
        var ab = Base64.decode(arr[1]);
        let a = document.createElement("a"); //创建一个a标签元素
        a.style.display = "none"; //设置元素不可见
        // a.target = "_blank";
        a.href = ab;
        document.body.appendChild(a); //加入
        a.click(); //触发点击,下载
        return;
      }
      let arrNew =
        toRaw(router).currentRoute.value.fullPath.split("ssoSessionId=");
      if (arrNew.length > 1) {
        localStorage.setItem("trsidsssosessionid", JSON.stringify(arrNew[1]));
      }
      const trsidsssosessionid = JSON.parse(
        localStorage.getItem("trsidsssosessionid")
      );
      if (trsidsssosessionid) {
        loginHandleClick();
      } else {
        loading = ElLoading.service({
          lock: true,
          text: "加载中...",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let a = document.createElement("a"); //创建一个a标签元素
        a.style.display = "none"; //设置元素不可见
        a.href = process.env.VUE_APP_BASE_URL + "/sys/getGssionid";
        document.body.appendChild(a); //加入
        a.click(); //触发点击,下载
        document.body.removeChild(a);
      }
    });

    return {
      loginHandleClick,
      handleChangeCheckCode,
      registerAccount,
      registerHandleClicks,
      registerHandleClick,
      reLogin,
      res,
      readmeFn,
      formData,
      checked1,
      randCodeData,
      type,
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log(to); //上一个页面前往的的页面(当前页面)
    console.log(from); //来自哪一个页面
    next((e) => {
      // 这个回调参数e,包含setup中暴露出去的数据以及内置方法
      window.console.log(e);
      // 获取是否来自home1页面
      if (from.path == "/home1") {
        e.obj.name = "李四";
      }
    });
  },
});
</script>

<style lang="scss" scoped>
.c:hover {
  cursor: pointer;
  background-color: #0ebeff !important;
}
.v:hover {
  cursor: pointer;
  border: 1px solid #0ebeff !important;
  color: #0ebeff;
}
.myBtn {
  width: 100%;
  height: 42px;
  border-radius: 5px;
  border: none;
}
.formItem {
  height: 70px;
}
.in2 {
  height: 46px !important;
}
::v-deep .in2 .el-input__wrapper {
  background: #f5f5f9;
}
.qq {
  color: #040404;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
}
.qq::after {
  content: "";
  position: absolute;
  z-index: 0;
  bottom: 12px;
  left: 18px;
  margin-left: -15px;
  width: 30px;
  height: 4px;
  background: #1b90ff;
  border-radius: 100px;
}
.title {
  padding-bottom: 21px;
  position: relative;
}
.ee {
  border-radius: 0 !important;
  flex-basis: 40% !important;
  -webkit-flex-basis: 40% !important;
  box-sizing: border-box;
  padding: 30px 20px !important;
  background: #fff !important;
  box-shadow: 2px 9px 49px -17px rgba(0, 0, 0, 0.1) !important;
}
.aui-image {
  padding: 180px 80px;
  flex-basis: 60%;
  -webkit-flex-basis: 60%;
  background-color: #fff;

  background-position: 10px;
  background-size: cover;
}
.hh {
  width: 100%;
  height: 100%;
  background: #eee;
  display: flex;
}
.aui-container {
  max-width: 1000px;
  margin: 0 auto;
  box-shadow: 0 4px 8px 1px rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 50%;
  left: 50%;
  width: 92%;
  height: 538px;
  background: #fff;
  transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
}
.icon-code,
.icon-password,
.icon-code {
  background-image: url("../../assets/loginmini/icon/icon-code.png");
  position: absolute;
  top: 10px;
  left: 0;
  width: 20px;
  height: 20px;
  display: block;
  border: none;
  float: left;
  background-size: 20px;
  background-repeat: no-repeat;
}
.aui-code {
  position: absolute;
  right: 8px;
  bottom: 0;
  width: 115px;
  cursor: pointer;
}
.icon-password {
  background-image: url("../../assets/loginmini/icon/icon-password.png");
}
.icon-code {
  background-image: url("../../assets/loginmini/icon/icon-code.png");
}
.el-input {
  height: 42px;
  border: none !important;
}
::v-deep .el-input__wrapper {
  box-shadow: none !important;
}
.inpRow {
  width: 100%;
  border-bottom: 1px solid #cccccc;
  position: relative;
  padding-left: 20px;
  background: #fff;
  margin-bottom: 8px;
  margin-top: 20px;
}
:root {
  --color: #0ebeff;
}

@keyframes rotate {
  100% {
    transform: translate(-50%, -50%) rotate(1turn);
  }
}

.btn {
  position: relative;
  z-index: 0;
  width: 160px;
  height: 80px;
  line-height: 80px;
  color: var(--color);
  font-size: 24px;
  border-radius: 6px;
  text-align: center;
  margin: auto;
  overflow: hidden;
  cursor: pointer;
  transition: 0.3s;
  // -webkit-box-reflect: below 10px linear-gradient(transparent, rgba(0, 0, 0, 0.4));

  &:hover {
    color: #fff;
    box-shadow: 0 0 5px var(--color), 0 0 25px var(--color);

    &::after,
    &::before {
      transition: 0.3s;
      background: var(--color);
    }
  }

  &::before {
    content: "";
    position: absolute;
    z-index: -2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 150%;
    height: 300%;

    background-repeat: no-repeat;
    background-size: 50% 50%;
    background-position: 0 0;
    background-image: conic-gradient(var(--color), var(--color));
    animation: rotate 2s linear infinite;
  }

  &::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;

    border-radius: 6px;
  }
}
.my-svg {
  margin: auto;
  overflow: visible;
  transform: rotate(90deg) scale(1.1, 1.16);
  // transform: rotate(35deg);
  z-index: 999;
}
.g-polygon-wrap,
.g-polygon-move {
  // fill: none;
  // stroke: #03ebf6;
  stroke-width: 6;
  stroke-linejoin: round;
  stroke-linecap: round;
}

.g-polygon-move {
  transform-origin: center center;
  // transform: scale(1.05);
  // box-shadow: 0 0 10px rgba(2, 189, 246, 0.6);
  stroke-width: 6;
  stroke-dasharray: 280, 700;
  stroke-dashoffset: 8;
  animation: move 2.4s infinite linear;
}

@keyframes move {
  0% {
    stroke-dashoffset: 8;
  }
  100% {
    stroke-dashoffset: -972;
  }
}
.btn {
  background: linear-gradient(0deg, rgb(0, 83, 255), rgb(16, 122, 245));
  border-radius: 6px;
  margin-top: 80px;
  font-family: youyuan;
  color: #fff;
}
.aui-formButton {
  padding-top: 10px;
}
.aui-flex-box {
  flex: 1;
  min-width: 0;
  display: flex;
}
.aui-form-box {
  height: 180px;
}
.aui-flex-box {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #333;
}
.aui-flex {
  display: flex;
  align-items: center;
  position: relative;
}
.aui-form-nav {
  text-align: center;
  padding-bottom: 20px;
}
.aui-content {
  padding: 40px 60px;
}
.my-container {
  width: 100%;
  display: flex;
  position: relative;
}
.my-container_r {
  transform: translateX(720px);
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: tranr 1s forwards;
}

.my-container_l {
  padding-top: 60px !important;
  box-sizing: border-box;
  flex: 3;
  transform: translateX(-965px);
  animation: tranl 1s forwards;
}

.enterName::after {
  content: attr(data-text);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 5;

  -webkit-background-clip: text;
  background-size: 150% 100%;
  background-repeat: no-repeat;
}

.enterName {
  font-size: 48px;
  color: #fff;
  letter-spacing: 6px;
  position: relative;
  font-family: "youyuan";
  color: transparent;
  background-color: #fff;
  -webkit-background-clip: text;
  text-align: center;
}
@font-face {
  font-family: "youyuan";
  src: url("../../assets/font/三极行楷简体-粗.ttf");
}
.enterLog {
  width: 577px;
  height: 652px;
  transform: translate(197px, -97px);
}
.bottom {
  font-size: 18px;
  text-align: center;
  color: #fff;
  letter-spacing: 4px;
}
.sign1 {
  position: absolute;
  top: 282px;
  left: 156px;
  animation: sign1 3s infinite;
}
.sign2 {
  position: absolute;
  top: 596px;
  left: 235px;
  animation: sign2 1s infinite;
}
.sign3 {
  position: absolute;
  top: 168px;
  left: 776px;
  animation: sign3 3s infinite;
}
.sign4 {
  position: absolute;
  top: 492px;
  left: 769px;
  animation: sign4 1s infinite;
}

.my-login_box {
  width: 440px;
  height: 550px;
}
.aui-formBox {
  width: 100%;

  border-radius: 33px;
  box-shadow: 0 31px 62px 0 rgba(0, 50, 118, 0.3);
  padding: 60px;
  box-sizing: border-box;
  background: #fff;
  -webkit-flex-basis: 40%;
}

@keyframes tranl {
  0% {
    transform: translateX(-965px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes tranr {
  0% {
    transform: translateX(720px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes sign1 {
  0% {
    top: 282px;
  }
  50% {
    top: 300px;
  }
  100% {
    top: 282px;
  }
}
@keyframes sign2 {
  0% {
    top: 596px;
  }
  50% {
    top: 600px;
  }
  100% {
    top: 596px;
  }
}
@keyframes sign3 {
  0% {
    top: 168px;
  }
  50% {
    top: 200px;
  }
  100% {
    top: 168px;
  }
}
@keyframes sign4 {
  0% {
    top: 492px;
  }
  50% {
    top: 500px;
  }
  100% {
    top: 492px;
  }
}
@keyframes shine {
  0% {
    background-position: 50% 0;
  }
  100% {
    background-position: -190% 0;
  }
}

:root {
  --color: #0ebeff;
}

@keyframes rotate {
  100% {
    transform: translate(-50%, -50%) rotate(1turn);
  }
}
.a {
  background: #fff;
  color: #3c3c3c !important;
  border: 1px solid #dbdbdb;
  margin-top: 16px !important;
  width: 160px;
  height: 42px;
  line-height: 80px;
}
.a:hover {
  color: #1b90ff !important;
  border: 1px solid #1b90ff;
}
.btn {
  color: #fff;
  position: relative;
  z-index: 0;
  width: 160px;
  height: 42px;
  line-height: 80px;

  border-radius: 6px;
  text-align: center;
  margin: auto;
  overflow: hidden;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    color: #fff;
    box-shadow: 0 0 5px #0ebeff, 0 0 25px #0ebeff;

    &::after,
    &::before {
      transition: 0.3s;
      background: #0ebeff;
    }
  }

  &::before {
    content: "";
    position: absolute;
    z-index: -2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 150%;
    height: 300%;

    background-repeat: no-repeat;
    background-size: 50% 50%;
    background-position: 0 0;
    background-image: conic-gradient(var(--color), var(--color));
    animation: rotate 2s linear infinite;
  }

  &::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;

    border-radius: 6px;
  }
}
.my-svg {
  margin: auto;
  overflow: visible;
  transform: rotate(90deg) scale(1.1, 1.16);
  // transform: rotate(35deg);
  z-index: 999;
}
.g-polygon-wrap,
.g-polygon-move {
  // fill: none;
  // stroke: #03ebf6;
  stroke-width: 6;
  stroke-linejoin: round;
  stroke-linecap: round;
}

.g-polygon-move {
  transform-origin: center center;
  // transform: scale(1.05);
  // box-shadow: 0 0 10px rgba(2, 189, 246, 0.6);
  stroke-width: 6;
  stroke-dasharray: 280, 700;
  stroke-dashoffset: 8;
  animation: move 2.4s infinite linear;
}

@keyframes move {
  0% {
    stroke-dashoffset: 8;
  }
  100% {
    stroke-dashoffset: -972;
  }
}
.loginCon {
  background: url("../../assets/img/beijingtu.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
